<template>
    <div class="wrapper">
        <!-- 表頭 -->
        <Header v-cloak />

        <div v-cloak class="content">
            <!-- steps -->
            <StatusStep />
            <!-- render body start-->
            <router-view v-slot="{ Component }" :key="route.fullPath">
                <transition enter-active-class="animate__animated animate__fadeIn" leave-active-class="animate__animated animate__fadeOut">
                    <component :is="Component" />
                </transition>
            </router-view>
            <!-- render body end -->
        </div>
        <Footer v-cloak />
    </div>
</template>

<script setup lang="ts">
import { RouteUrlList } from '@/libs/RouteList';
import { RouterView, useRoute } from 'vue-router';
import Header from '@/components/share/Header.vue';
import Footer from '@/components/share/Footer.vue';
import { defineAsyncComponent, ref, watch, onMounted } from 'vue';
import { useBeforeUnload } from '@/hooks/useBeforeUnload';
import { usePreventPopState } from './hooks/usePreventPopState';
import { useLeaveProtectionStore } from '@/stores/modules/leaveProtection';
import * as Common from '@/libs/Common';
import 'animate.css';

const hideStatusSteps = ref(false);
const hideStatusStepsPaths = [RouteUrlList.Login.path.toLowerCase()];
const route = useRoute();

useBeforeUnload((event: BeforeUnloadEvent) => {
    const leaveProtectionStore = useLeaveProtectionStore();
    if (leaveProtectionStore.hasUnsavedChanges) {
        event.preventDefault();
    }
});

usePreventPopState();

watch(
    () => route.path,
    async (toPath) => {
        Common.ConsoleLog(`[App.vue]:顯示步驟數判斷`);
        const _targetPath = toPath.trim().toLowerCase();
        if (_targetPath === '/') {
            hideStatusSteps.value = true;
        } else {
            hideStatusSteps.value = hideStatusStepsPaths.indexOf(_targetPath) !== -1;
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    { immediate: true }
);

onMounted(() => {
    document.onreadystatechange = () => {
        if (document.readyState == 'complete') {
            document.querySelector('.loading')?.classList.add('loading--remove');
        }
    };
});

const StatusStep = defineAsyncComponent(() => import('@/components/share/StatusStep.vue'));
</script>

<style>
[v-cloak] {
    display: none !important;
}
.btn {
    padding-block: 1px;
    padding-inline: 6px;
}
.btn-long-text {
    min-width: 200px !important;
    width: fit-content !important;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
